module.exports = __webpack_public_path__ + "img/pin_transport_green.2701409d.svg";